import BasePlayer from 'services/sports/default/base-player';
import {getDefaultExposure} from 'helpers/player-helper';
import Action from 'actions';
import Const from 'constants';

export default class Player extends BasePlayer {
    resetSettings({incomingValues: {dispatch}}) {
        const {
            playersData: {players},
            userPointsType,
        } = Action.getState();

        const playersUserPoints = [];
        const captainsUserPoints = [];
        const playersExposure = [];

        players.getAllAsArr().map((player) => {
            playersUserPoints.push({
                playerId: player.playerId,
                userPoints: this.exec('applySympathyToPoints', {
                    player,
                    points: player[userPointsType.getUserPointsType()],
                }),
            });

            captainsUserPoints.push({
                playerId: player.playerId,
                userPoints: this.exec('applySympathyToPoints', {
                    player,
                    points: player.getPropValueOfMode(userPointsType.getUserPointsType(), Const.CAPTAIN_MODE),
                    mode: Const.CAPTAIN_MODE,
                }),
            });

            playersExposure.push({
                playerId: player.playerId,
                exposureMin: getDefaultExposure('min'),
                exposureMax: getDefaultExposure('max'),
            });
        });

        dispatch(Action.do('resetExcludePlayersByRange'));
        dispatch(Action.set('PlayersExposure', playersExposure));
        dispatch(Action.set('UserPoints', playersUserPoints, Const.FLEX_MODE, false));
        dispatch(Action.set('UserPoints', captainsUserPoints, Const.CAPTAIN_MODE, false));

        return true;
    }
}
